import React from "react";
import {
  FileInput,
  InputGroup,
  FormGroup,
  Dialog,
  Classes,
  Intent,
  Button,
  HTMLSelect
} from "@blueprintjs/core";

class DialogAddInterlude extends React.Component {
  render() {
    const {
      interlude,
      dialogIsOpen,
      submiting,
      onCloseDialog,
      onChangeInput,
      onChangeInputFile,
      onAddInterlude
    } = this.props;

    return (
      <Dialog
        icon="add"
        title="Add Introduction"
        autoFocus={true}
        canEscapeKeyClose={true}
        canOutsideClickClose={true}
        usePortal={true}
        enforceFocus={true}
        isOpen={dialogIsOpen}
        onClose={onCloseDialog}
      >
        <div className={Classes.DIALOG_BODY}>
          <FormGroup label="File type" labelFor="interlude-type">
            <HTMLSelect
              id="interlude-type"
              fill={true}
              name="type"
              defaultValue={interlude.type || "UNK"}
              onChange={onChangeInput}
            >
              <option disabled value="UNK">
                Choose type
              </option>
              <option value="IMAGE">Image</option>
              <option value="VIDEO">Video</option>
            </HTMLSelect>
          </FormGroup>
          <FormGroup label="Name" labelFor="interlude-name" disabled={submiting}>
            <InputGroup
              id="interlude-name"
              onChange={onChangeInput}
              name="name"
              disabled={submiting}
            />
          </FormGroup>
          <FormGroup
            label="File"
            labelFor="interlude-file"
            disabled={submiting}
          >
            <FileInput
              id="interlude-file"
              fill={true}
              inputProps={{ name: "file" }}
              onInputChange={onChangeInputFile}
              disabled={submiting}
              text={interlude.file || "Choose a file..."}
            />
          </FormGroup>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              onClick={onCloseDialog}
              text="Cancel"
              disabled={submiting}
            />
            <Button
              onClick={onAddInterlude}
              text="Add"
              intent={Intent.SUCCESS}
              rightIcon="add"
              disabled={
                submiting ||
                interlude.file == null ||
                interlude.fileBlob == null ||
                interlude.name == null
              }
              loading={submiting}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}

export default DialogAddInterlude;
